import React, { useState } from "react";
import "./style.scss";

import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

import { defaultProps } from "./props/defaultProps";
import { propTypes } from "./props/propTypes";
import { useStateValue } from "../../store";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="standard" {...props} />;
});

// severity="error"
// severity="warning"
//severity="info"
// severity="success"

const Index = () => {
  const [{ alertMessage }, dispatch] = useStateValue();
  const [open, setOpen] = useState(true);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch({
      type: "SET_ALERT_MESSAGE",
      value: false,
      data: { severity: "", message: "" },
    });
    setOpen(false);
  };
  const handleExited = () => {
    dispatch({
      type: "SET_ALERT_MESSAGE",
      value: false,
      data: { severity: "", message: "" },
    });
  };
  return (
    <Stack spacing={2} sx={{ width: "100%" }}>
      <Snackbar
        open={open}
        autoHideDuration={4000}
        onClose={handleClose}
        onExited={handleExited}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleClose}
          severity={alertMessage?.alertData?.severity}
          sx={{ width: "100%" }}
        >
          {alertMessage?.alertData?.message}
        </Alert>
      </Snackbar>
    </Stack>
  );
};

export default Index;

Index.defaultProps = defaultProps;
Index.propTypes = propTypes;
